import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';

@MergeSchema({
    entity: ActivityEntityName.Contact
})
export class AccountContactMergeData {

    @MergeField()
    firstName: string;

    @MergeField()
    lastName: string;

    @MergeField()
    name: string;

    @MergeField()
    email: string;

    @MergeField()
    mobile: string;

    @MergeField()
    workPhone: string;

    @MergeField()
    jobTitle: string;

    @MergeField({
        hidden: true
    })
    phone: string;

    parents: Entity[]

    sites: Entity[]

    customFields: any;
}

export const AccountContactMergeSchema = getSchema(AccountContactMergeData);